// コンテナクエリが使えないブラウザ（2026-10-21 に app.js から分けた）
import { $ } from './util.js';

// ---- コンテナクエリが使えないブラウザ（iOS 15・Chrome 104 以下） ----
// キャラの四角（.stage-box の width: min(100cqw, 100cqh)）の大きさと、キャラの段の大きさで調整の列などを詰める @container の判定を、
// .stage-area の中身の大きさを測って代わりにする（html に no-cq、.stage-area に cq-h400・cq-h330・cq-w620）
export function fitWithoutContainerQueries() {
  if (window.CSS && CSS.supports && CSS.supports('width', '1cqw')) return;
  document.documentElement.classList.add('no-cq');
  const area = document.querySelector<HTMLElement>('.stage-area')!, box = $('stageBox');
  const fit = () => {
    const cs = getComputedStyle(area);
    const w = area.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    const h = area.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    const side = Math.max(0, Math.floor(Math.min(w, h)));
    box.style.width = side + 'px';
    box.style.height = side + 'px';
    area.classList.toggle('cq-h400', h <= 400);
    area.classList.toggle('cq-h330', h <= 330);
    area.classList.toggle('cq-w620', w <= 620);
  };
  if (window.ResizeObserver) new ResizeObserver(fit).observe(area);
  else window.addEventListener('resize', fit);
  fit();
}
